import { createSlice } from '@reduxjs/toolkit';
import {
    getTradeSupportBuyers,
    getTradeSupportSummary,
    getTradeSupportTransactions,
    getSupplierCreditFacilitySummary,
    getSupplierCreditFacilityTransactions,
} from '../actions/tradeSupportApi';

const initialState = {
    buyers: [],
    selectedBuyerUlid: null,
    summary: null,
    transactions: [],
    transactionsCategory: null,
    transactionPagination: { has_next: false, next_cursor: null, totalCount: null },
    loading: {
        buyers: false,
        summary: false,
        transactions: false,
    },
    error: {
        buyers: null,
        summary: null,
        transactions: null,
    },
};

export const tradeSupportSlice = createSlice({
    name: 'tradeSupport',
    initialState,
    reducers: {
        setSelectedBuyerUlid: (state, action) => {
            state.selectedBuyerUlid = action.payload;
            state.summary = null;
            state.transactions = [];
            state.transactionsCategory = null;
            state.transactionPagination = { has_next: false, next_cursor: null, totalCount: null };
        },
        setTransactionsCategory: (state, action) => {
            state.transactionsCategory = action.payload;
            state.transactions = [];
            state.transactionPagination = { has_next: false, next_cursor: null, totalCount: null };
        },
        clearTradeSupportState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTradeSupportBuyers.pending, (state) => {
                state.loading.buyers = true;
                state.error.buyers = null;
            })
            .addCase(getTradeSupportBuyers.fulfilled, (state, action) => {
                state.loading.buyers = false;
                state.buyers = action.payload?.buyers ?? action.payload ?? [];
            })
            .addCase(getTradeSupportBuyers.rejected, (state, action) => {
                state.loading.buyers = false;
                state.error.buyers = action.payload;
                state.buyers = [];
            })
            .addCase(getTradeSupportSummary.pending, (state) => {
                state.loading.summary = true;
                state.error.summary = null;
            })
            .addCase(getTradeSupportSummary.fulfilled, (state, action) => {
                state.loading.summary = false;
                state.summary = action.payload;
            })
            .addCase(getTradeSupportSummary.rejected, (state, action) => {
                state.loading.summary = false;
                state.error.summary = action.payload;
                state.summary = null;
            })
            .addCase(getTradeSupportTransactions.pending, (state) => {
                state.loading.transactions = true;
                state.error.transactions = null;
            })
            .addCase(getTradeSupportTransactions.fulfilled, (state, action) => {
                state.loading.transactions = false;
                state.transactions = action.payload.transactions;
                state.transactionPagination = {
                    has_next: action.payload.has_next,
                    next_cursor: action.payload.next_cursor,
                    totalCount: action.payload.totalCount,
                };
            })
            .addCase(getTradeSupportTransactions.rejected, (state, action) => {
                state.loading.transactions = false;
                state.error.transactions = action.payload;
                state.transactions = [];
            })
            .addCase(getSupplierCreditFacilitySummary.pending, (state) => {
                state.loading.summary = true;
                state.error.summary = null;
            })
            .addCase(getSupplierCreditFacilitySummary.fulfilled, (state, action) => {
                state.loading.summary = false;
                state.summary = action.payload;
            })
            .addCase(getSupplierCreditFacilitySummary.rejected, (state, action) => {
                state.loading.summary = false;
                state.error.summary = action.payload;
                state.summary = null;
            })
            .addCase(getSupplierCreditFacilityTransactions.pending, (state) => {
                state.loading.transactions = true;
                state.error.transactions = null;
            })
            .addCase(getSupplierCreditFacilityTransactions.fulfilled, (state, action) => {
                state.loading.transactions = false;
                state.transactions = action.payload.transactions;
                state.transactionPagination = {
                    has_next: action.payload.has_next,
                    next_cursor: action.payload.next_cursor,
                    totalCount: action.payload.totalCount,
                };
            })
            .addCase(getSupplierCreditFacilityTransactions.rejected, (state, action) => {
                state.loading.transactions = false;
                state.error.transactions = action.payload;
                state.transactions = [];
            });
    },
});

export const { setSelectedBuyerUlid, setTransactionsCategory, clearTradeSupportState } = tradeSupportSlice.actions;

export default tradeSupportSlice.reducer;
